import { Component, OnInit } from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { Observable } from 'rxjs';
import { RealtimedbService } from 'app/firebase/realtimedb.service';


@Component({
  selector: 'display-bulletins',
  templateUrl: './display-bulletins.component.html',
  styleUrls: ['./display-bulletins.component.scss']
})
export class DisplayBulletinsComponent implements OnInit{

    /**
     * Render list. Bulletins to render, in case we need to stack them or update their state.
     */
    displayList: {} = {}

    /**
     * Observable attached to the RTDB collecting bulletins.
     */
    b$: Observable<any>;

    /**
     * Constructor.
     * @param userService Used to determine user characteristics.
     * @param rtdb Realtime database service used to grab the bulletin data.
     */
    constructor(private userService: UserService, private rtdb: RealtimedbService){}

    /**
     * Grabs the user data, then with that context goes on to ping the db and render the string.
     * Interesting way of doing things when you picture how the call stack looks.
     */
    ngOnInit() {
        // Grab the current user's info.
        this.userService.user$.subscribe( (next) =>{ this.getModuleData(next) },
                                          (error)=>{ console.log("usererror",error) },
                                          ()     =>{ console.log("usercomplete") } );

    }

    /**
     * Grabs module data from the DB, then recursively calls the render func with that data.
     * @param user Information regarding the current user.
     */
    getModuleData(user) {
        // Get the bulletin observer.
        this.b$ = this.rtdb.getOnChange('bulletin_list');

        // Subscribe to the observer, create the a list from its contents, and render the page.
        this.b$.subscribe((next)=>{
                            let b = {};
                            for ( var d in next ) {
                                let key = next[d].payload.key;
                                let value = next[d].payload.val();
                                b[key] = value;
                            }
                            this.renderData(b, user)
                          },
                          (error)=>{console.log("error",error)},
                          ()=>{console.log("complete")});
    }

    /**
     * Populates / updates the render list, based on the current user.
     * @param bulletins Bulletin data.
     * @param user User data
     */
    renderData(bulletins, user) {

        // Pull out the user data we care about re: vis testing for easy access.
        let org = user['organization'];
        let id  = user['id'];

        // Go through all the bulletins, and if the current user is meant to see them,
        // add them to the render list.
        for ( let key in bulletins ) {

            // All users? easy.
            let b = bulletins[key];
            if ( b['visibleTo'] == 'all' ) {
                this.displayList[key] = b;
            }

            else {

                // console.log(b['visibleTo']);

                let vis = b['visibleToSpecifier'];

                // If an empty list is supplied, Google culls the field for the object.
                if ( !vis ) continue;

                if (b['visibleTo'] == 'org_list' && vis.includes(org) ) {  // org
                    this.displayList[key] = b;
                }
                else if (b['visibleTo'] == 'user_list' && vis.includes(id) ) {  // user
                    this.displayList[key] = b;
                }
                else if (this.displayList.hasOwnProperty(key)) { // Cull any bulletin that the user has been removed from.
                    delete this.displayList[key];
                }
            }
        }

        // Now we also need to check to see if a bulletin has been removed.
        let existingKeys = Object.keys(bulletins);
        for ( let key in this.displayList ) {
            if ( ! existingKeys.includes(key) ) {
                delete this.displayList[key];
            }
        }
    }
}